 <script setup>
 import { computed } from "vue";

const props = defineProps({
	progress: {
		type: Number
	}
})

//helper functions

const uploadProgress = computed(() => {
   return parseInt(props.progress * 100) + '%'
});

const uploadIncomplete = computed(() => {
    if (props.progress < 1) {
        return true;
    } else return false;
});

 </script>
 
 
 <template>
	 <div class="w-full h-2 bg-slate-300 box-border rounded flex">
		 <div v-if="!uploadIncomplete" class=" bg-Green-500 rounded w-full" ></div>
					<div v-else class="progress-bar"
					:style="'width: ' + uploadProgress "  
					></div>
				</div>
 </template>

<style>

.progress-bar {
    transition: width linear 0.15s;
	background-color: #0068FA;
	border-radius: 0.25rem;
}

</style>